import React from "react";
import "../Lab/Lab.css";
import infrastructure from "../Assets/Infrastructure.jpg";
import inhelers_img from "../Assets/background_img.jpg";
import approved from "../Assets/approved.png";
import image from '../Assets/ai-image.jpg'
function Lab() {
  return (
    <>
      <div className="lab">
        <div className="lab-div">
          <div className="lab-div-image">
            <img
              src={infrastructure}
              alt="infrastructure-image"
              className="lab-div-image"
            />
          </div>
          <div className="lab-div-contain">
            <h2>Infrastructure</h2>
            <p className="lab-div-text">
              State-of-the-art lab set up with high quality instrumentation.
            </p>
          </div>
        </div>
        {/* <hr /> */}
        <div className="lab-div">
          <div className="lab-div-image">
            <img
              src={inhelers_img}
              alt="inhelers-image"
              className="lab-div-image"
            />
          </div>
          <div className="lab-div-contain">
            <h2>Expertise in Inhalation</h2>
            <p className="lab-div-text">
              Highly motivated team with experience in all inhaled dosage forms.
            </p>
          </div>
        </div>
        {/* <hr /> */}
        <div className="lab-div">
          <div className="lab-div-image">
            <img
              src={image}
              alt="inhelers-image"
              className="lab-div-image "
            />
            <div className="lab-quality-div">
              <img src={approved}
              alt="inhelers-image"
              className="lab-quality-div-image"/>
            </div>
            
          </div>
          <div className="lab-div-contain">
            <h2>Focus on quality</h2>
            <p className="lab-div-text">
            Staying true to our values and mission statement of delivering high
            quality analysis with extensive reports in fast turn around times.
            </p>
          </div>
        </div>
        {/* <div className="lab-div lab-quality-div">
          <img src={approved} alt="approved" className="lab-image" />
          <h2>Focus on quality</h2>
          <p className="lab-div-text">
            Staying true to our values and mission statement of delivering high
            quality analysis with extensive reports in fast turn around times.
          </p>
        </div> */}
      </div>
    </>
  );
}
export default Lab;
